class Account {
  constructor() {
    this.addAddressFormToggle();
    this.editAddressFormToggle();
  }

  addAddressFormToggle() {
    this.newAddressToggles = [].slice.call(
      document.querySelectorAll('.address-new-toggle')
    )

    const newAddressForm = document.querySelector('.address-form--new')

    this.newAddressToggles.forEach(toggle => {
      ['click', 'keypress'].forEach(event => {
        toggle.addEventListener(event, e => {
          let key = e.which || e.keyCode;
          if (key === 13 || e.type === 'click') {
            newAddressForm.classList.toggle('active');
          }
        });
      });
    });
  }

  editAddressFormToggle() {
    this.editAddressToggles = [].slice.call(
      document.querySelectorAll('.address-edit-toggle')
    )

    this.editAddressToggles.forEach(toggle => {
      ['click', 'keypress'].forEach(event => {
        toggle.addEventListener(event, e => {
          let key = e.which || e.keyCode;
          let editAddressForm = toggle.nextElementSibling;

          if (key === 13 || e.type === 'click') {
            editAddressForm.classList.toggle('active');
          }
        });
      });
    });
  }
}

const accountInit = {
  init() {
    // if element exists init this class
    const accountElem = [].slice.call(
      document.querySelectorAll('.account')
    );
    if (accountElem.length > 0) {
      new Account();
    }
  }
};

export default accountInit;
